<!--  -->
<template>
  <div class="content">
    <div class="ban" >
     <!-- <img src="http://www.hitaledu.com/img/trade.png" alt="湖南生易圈教育咨询有限公司" /> -->
     <img src="../../img/ban1.jpg" alt="湖南生易圈教育咨询有限公司" /> 
     <div class="ban_bot">
      <div @click="topUrl(3, '/Contact_us')">
        联系我们
      </div>
      <div @click="url">
        证书查询
      </div>
     </div>
    </div>
    <!-- 平台介绍 -->
    <div class="Platform_introduction">
      <div class="card">
        <div class="left">
          <div class="Freight">
            Foreign <br />
            trade Skills<br />
            Training
          </div>
          <div class="title">产品介绍</div>
          <img class="img" src="../../assets/servie/line.png" alt="湖南生易圈教育咨询有限公司" />
          <div class="info">
            <div>在集团公司积极实施湖南省商务厅承建园区外贸综合服务中心，为园区企业提供全产业链的外贸综合服务基础上，专门打造商务系统外贸专项培训解决方案。</div>
            <div>
                        帮助各地区解决外贸人才技能提升问题，为区域外向型经济发展提供人才支撑，助力湖南外向型经济持续保持良好的增长态势。
            </div>
          </div>
          <div class="card_img ">
        <div class="top">
          <div class="img_title">
            培训特色
          </div>
          
          <img class="img1" src="../../assets/trade/ico.png" alt="湖南生易圈教育咨询有限公司">
        </div>
        <div class="img_text">
          以一线的经验、活跃的课堂、团队的激励、专业的讲师，手把手教你做外贸。

        </div>
      </div>
          <!-- <div class="bott" @click="topUrl(3, '/Contact_us')">免费试用</div> -->
        </div>
      </div>
      <div class="left">
        <img class="left_img" src="../../assets/trade/img.png" alt="湖南生易圈教育咨询有限公司" />
      </div>
      
    </div>
     <!-- 我们的过往案例 -->
    <div class="case swiper-container">
      <Link text="精选案例" />

      <div
        trigger="click"
        class="lbt swiper mySwiper"
        height="420px"
        indicator-position="outside"
      >
        <div class="list swiper-wrapper">
          <div class="li swiper-slide" v-for="(item,index) in anli_list" :key="index">
             <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.year }}</div>
              <div class="text width">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
         <div style="margin-top:20px" class="swiper-pagination"></div>
      </div>
    </div>

  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      six_list: [
        {
          title: "线上实操",
          text: "数字化操作实现数据精准有效填写。",
          background: "url(" + require("../../assets/servie/1.png") + ")",
        },
        {
          title: "智能对比",
          text: "学生在实操录入后，系统会自动进行数据对比。",
          background: "url(" + require("../../assets/servie/2.png") + ")",
        },
        {
          title: "智能评分",
          text: "全流程记录学生实际录入操作，进行积分制，系统自动评分。",
          background: "url(" + require("../../assets/servie/3.png") + ")",
        },
        {
          title: "成绩管理",
          text: "快速查询学生实操结果，并统计所有实操信息。",
          background: "url(" + require("../../assets/servie/4.png") + ")",
        },
        {
          title: "案例管理",
          text: "老师可在丰富的案例库中挑选实操案例和上传实操案例信息。",
          background: "url(" + require("../../assets/servie/5.png") + ")",
        },
        {
          title: "学员管理",
          text: "学生可操作世界技能大赛货运代理项目比赛试题。",
          background: "url(" + require("../../assets/servie/6.png") + ")",
        },
      ],
      card_list: [
        {
          img: require("../../assets/servie/13.png"),
          text: "案例管理",
        },
        {
          img: require("../../assets/servie/ioc1.png"),
          text: "现场管理",
        },
        {
          img: require("../../assets/servie/ioc3.png"),
          text: "报价管理",
        },
        {
          img: require("../../assets/servie/ioc4.png"),
          text: "单证管理",
        },
        {
          img: require("../../assets/servie/ioc5.png"),
          text: "操作管理",
        },
        {
          img: require("../../assets/servie/14.png"),
          text: "统计查询",
        },
        {
          img: require("../../assets/servie/ioc12.png"),
          text: "档案管理",
        },
        {
          img: require("../../assets/servie/ioc8.png"),
          text: "成绩管理",
        },
        {
          img: require("../../assets/servie/ioc7.png"),
          text: "成绩分析",
        },
        {
          img: require("../../assets/servie/15.png"),
          text: "竞赛题库",
        },
      ],
      price_list: [
        {
          img: require("../../assets/servie/Icon1.png"),
          title: "实训课程整体解决方案",
          text: "将企业案例带入课堂实景教学使用平台模拟真实操作满足高校专业所需",
          pric: "8000-20000",
          danwei: "元/天",
        },
        {
          img: require("../../assets/servie/Icon2.png"),
          title: "竞赛租用",
          text: "结合比赛模块进行模拟训练帮助选手熟练掌握操作技巧",
          pric: "49800",
          danwei: "元/学期",
        },
        {
          img: require("../../assets/servie/Icon3.png"),
          title: "平台采购",
          text: "根据客户需求进行定制化案例搭配提供贴合需求的售后服务",
          pric: "168000",
          danwei: "元",
        },
        {
          img: require("../../assets/servie/Icon4.png"),
          title: "定制开发",
          text: "通过院校理论支持与企业实际案例相结合，共享资源，打造专属特色软件",
          pric: "商谈",
          danwei: "",
        },
      ],
      anli_list: [
        {
          img: require("../../assets/trade/al_01.png"),
          title: "湖南省商务厅",
          year: "2017年至今",
          text: "我司自2017年开始，与湖南省商务厅培训中心合作开展“千人千万”培训计划，共实施全省外贸人才培训班21期，累计培养2100名外贸人才。",
        },
        {
          img: require("../../assets/trade/al_02.png"),
          title: "雨花区商务局",
          year: "2021年9月",
          text: " 我司承办长沙市雨花区商务局2021年度外贸专题培训，为期4天，培训邀请实操型外贸专家为企业答疑解惑，传授经验。",
        },
        {
          img: require("../../assets/trade/al_03.png"),
          title: "中国报关协会",
          year: "2019年11月",
          text: "承办归类专项培训活动，以活跃的课堂氛围，让专业讲师与岗位职工面对面探讨各项疑难杂症。",
        },
        {
          img: require("../../assets/trade/al_04.png"),
          title: "湖南中冶长天重工科技有限公司",
          year: "2019年10月",
          text: "对客户综合管理、市场营销、设备制造、财务等20余人实施主题为《海外业务》的培训，让业务相关人员学习外贸全流程知识及退税相关内容，扩大海外市场业务，规避风险。",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    url(){
      window.open('https://www.sinoetrade.com/index.php/Index/train/?5')
    },
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
      var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on:{
        
        }
      });
       $('#btn1').click(function(){
    alert(mySwiper.activeIndex); 
  })
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../trade/pc);
@import url(../trade/mod);
</style>